module.exports = __webpack_public_path__ + "static/media/dayLimitPlus.84ebb341.svg";